import { Controller } from "@hotwired/stimulus"
import CSVBoxImporter from "@csvbox/csvboxjs"
import RequestHelper from "../helpers/request_helper.js"

export default class extends Controller {
  open(event) {
    event.preventDefault();
    const data = event.currentTarget.dataset;
    this.lookupUrlTemplate = data.importLookupUrlTemplate;

    const importer = new CSVBoxImporter(data.csvboxLicenseKey, {}, (success, result) => {
      this.handleImportResult(success, result);
    });

    const contactListSelect = document.getElementById("contact_import_contact_list_id");
    importer.setUser({
      user_id: data.userid,
      email: data.email,
      organization_id: data.organizationid,
      contact_list_id: contactListSelect ? contactListSelect.value : "",
      type: "contact_import"
    });
    importer.openModal();
  }

  // Rows are validated and the Contact::Import created server-side by
  // Hooks::CsvboxesController, which csvbox posts to directly - this only
  // fires once csvbox reports overall success, to resolve its import_id into
  // ours and kick off the ActionCable progress stream.
  handleImportResult(success, result) {
    if (!success || !result || !result.import_id) { return; }

    const url = this.lookupUrlTemplate.replace("EXTERNAL_IMPORT_ID", result.import_id);
    fetch(url, RequestHelper.defaultRequestOptions()).
      then(response => response.json()).
      then(json => {
        this.element.dispatchEvent(new CustomEvent("csvbox:imported", { detail: json, bubbles: true }));
      });
  }
}
